"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.upload.mode.title': 'Scegli Metodo di Inserimento Dati',
    'trainer.upload.mode.file': 'Carica File CSV',
    'trainer.upload.mode.manual': 'Inserimento Manuale',
    'trainer.upload.mode.pdf': 'Elaborazione PDF',
    'trainer.upload.mode.file.description': 'Carica un file CSV preformattato con i tuoi dati di addestramento',
    'trainer.upload.mode.manual.description': 'Crea dati di addestramento usando un\'interfaccia modulo user-friendly',
    'trainer.upload.mode.pdf.description': 'Carica un PDF per estrarre automaticamente e generare dati di addestramento dai capitoli',
    'trainer.upload.title': 'Carica Dati di Addestramento (CSV)',
    'trainer.upload.format.required': 'Formato CSV Richiesto:',
    'trainer.upload.format.input': 'Il testo del prompt/domanda',
    'trainer.upload.format.output': 'La risposta/risultato atteso',
    'trainer.upload.format.category': 'Categoria di classificazione',
    'trainer.upload.format.optional': 'opzionale',
    'trainer.upload.format.metadata': 'Colonne di metadati aggiuntivi sono supportate e verranno preservate.',
    'trainer.upload.processing': 'Elaborazione file...',
    'trainer.upload.select': 'Seleziona File CSV',
    'trainer.upload.file.info': 'Informazioni File',
    'trainer.upload.file.name': 'Nome file:',
    'trainer.upload.file.size': 'Dimensione:',
    'trainer.upload.file.type': 'Tipo:',
    'trainer.upload.data.analysis': 'Analisi Dati',
    'trainer.upload.stats.samples': 'Campioni di Addestramento',
    'trainer.upload.stats.input.length': 'Lunghezza Media Input',
    'trainer.upload.stats.output.length': 'Lunghezza Media Output',
    'trainer.upload.stats.categories': 'Categorie',
    'trainer.upload.stats.quality': 'Punteggio Qualità',
    'trainer.upload.categories.found': 'Categorie trovate:',
    'trainer.upload.preview': 'Anteprima Dati (Prime 3 righe)',
    'trainer.upload.preview.input': 'Input',
    'trainer.upload.preview.output': 'Output',
    'trainer.upload.preview.category': 'Categoria',
    'trainer.upload.manual.title': 'Crea Dati di Addestramento Manualmente',
    'trainer.upload.manual.description': 'Aggiungi esempi di addestramento uno per uno usando il modulo sottostante. Ogni esempio dovrebbe contenere un prompt di input e la risposta attesa.',
    'trainer.upload.manual.input': 'Input (Prompt)',
    'trainer.upload.manual.input.placeholder': 'Inserisci il prompt o la domanda...',
    'trainer.upload.manual.output': 'Output (Risposta)',
    'trainer.upload.manual.output.placeholder': 'Inserisci la risposta attesa...',
    'trainer.upload.manual.category': 'Categoria (Opzionale)',
    'trainer.upload.manual.category.placeholder': 'Inserisci un\'etichetta categoria...',
    'trainer.upload.manual.add': 'Aggiungi Voce',
    'trainer.upload.manual.update': 'Aggiorna Voce',
    'trainer.upload.manual.cancel': 'Annulla Modifica',
    'trainer.upload.manual.edit': 'Modifica',
    'trainer.upload.manual.delete': 'Elimina',
    'trainer.upload.manual.list.title': 'Voci Dati di Addestramento',
    'trainer.upload.manual.export': 'Esporta come CSV',
    'trainer.upload.manual.validation.required': 'Entrambi i campi input e output sono richiesti',
    'trainer.upload.manual.export.empty': 'Nessun dato di addestramento da esportare',
    'trainer.upload.pdf.title': 'Generazione Dati di Addestramento PDF',
    'trainer.upload.pdf.description': 'Carica un documento PDF per estrarre automaticamente il testo e generare dati di addestramento organizzati per capitoli.',
    'trainer.upload.pdf.upload.title': 'Carica Documento PDF',
    'trainer.upload.pdf.select': 'Seleziona File PDF',
    'trainer.upload.pdf.processing': 'Elaborazione PDF...',
    'trainer.upload.pdf.extracting': 'Estrazione capitoli...',
    'trainer.upload.pdf.context.label': 'Contesto (Opzionale)',
    'trainer.upload.pdf.context.placeholder': 'Fornisci contesto aggiuntivo sul contenuto del documento per migliorare la qualità dei dati di addestramento...',
    'trainer.upload.pdf.extract.button': 'Estrai Capitoli',
    'trainer.upload.pdf.chapters.title': 'Capitoli Estratti',
    'trainer.upload.pdf.chapters.select': 'Seleziona capitoli da elaborare:',
    'trainer.upload.pdf.chapters.selectall': 'Seleziona Tutto',
    'trainer.upload.pdf.chapters.deselectall': 'Deseleziona Tutto',
    'trainer.upload.pdf.chapters.generate.button': 'Genera Dati di Addestramento dai Capitoli Selezionati',
    'trainer.upload.pdf.chapters.generating': 'Generazione dati di addestramento...',
    'trainer.upload.pdf.chapters.preview': 'Anteprima:',
    'trainer.upload.pdf.chapters.words': 'parole',
    'trainer.upload.pdf.file.info': 'Informazioni PDF',
    'trainer.upload.pdf.file.name': 'Nome file:',
    'trainer.upload.pdf.file.size': 'Dimensione:',
    'trainer.upload.pdf.file.pages': 'Pagine:',
    'trainer.upload.pdf.success': 'Dati di addestramento generati con successo!',
    'trainer.upload.pdf.error': 'Errore nell\'elaborazione PDF. Riprova.',
    'trainer.upload.pdf.error.extraction': 'Errore nell\'estrazione dei capitoli dal PDF',
    'trainer.upload.pdf.error.generation': 'Errore nella generazione dei dati di addestramento',
    'trainer.upload.pdf.error.nofile': 'Si prega di selezionare un file PDF',
    'trainer.upload.pdf.error.nochapters': 'Si prega di selezionare almeno un capitolo',
};
